<template>
  <div id="realVideo">
    <consoleCamera :videoId="options.id" v-show="!failShow" />
    <div id="player"></div>
    <div class="loadImg" v-show="loading">
      <img :src="require('@/assets/images/loading.gif')" />
    </div>
    <div class="failtip" v-show="failShow">播放失败</div>
  </div>
</template>
<script>
import consoleCamera from "./newHikVideo.vue";
export default {
  components: {
    consoleCamera,
  },
  props: ["options"],
  data() {
    return {
      // 遮罩层
      loading: true,
      player: null,
      //高级模式
      mode: 0,
      urls: {
        realplay: "",
      },
      //请求失败次数
      failNum: 0,
      failShow: false,
    };
  },
  methods: {
    init() {
      // 设置播放容器的宽高并监听窗口大小变化
      window.addEventListener("resize", () => {
        this.player.JS_Resize();
      });
    },
    createPlayer() {
      this.player = new window.JSPlugin({
        szId: "player",
        szBasePath: "/static/js/",
        iMaxSplit: 1,
        iCurrentSplit: 1,
        openDebug: true,
        oStyle: {
          borderSelect: "#FFCC00",
          background: "#4C4C4C",
        },
      });
      this.player.JS_Resize();
      // 事件回调绑定
      this.player.JS_SetWindowControlCallback({
        windowEventSelect: function (iWndIndex) {
          //插件选中窗口回调
          // console.log('windowSelect callback: ', iWndIndex)
        },
        pluginErrorHandler: function (iWndIndex, iErrorCode, oError) {
          //插件错误回调
          console.log("pluginError callback: ", iWndIndex, iErrorCode, oError);
        },
        windowEventOver: function (iWndIndex) {
          //鼠标移过回调
          //console.log(iWndIndex);
        },
        windowEventOut: function (iWndIndex) {
          //鼠标移出回调
          //console.log(iWndIndex);
        },
        windowEventUp: function (iWndIndex) {
          //鼠标mouseup事件回调
          // console.log(iWndIndex)
        },
        windowFullCcreenChange: function (bFull) {
          //全屏切换回调
          // console.log('fullScreen callback: ', bFull)
        },
        firstFrameDisplay: function (iWndIndex, iWidth, iHeight) {
          //首帧显示回调
          // console.log('firstFrame loaded callback: ', iWndIndex, iWidth, iHeight)
        },
        performanceLack: function () {
          //性能不足回调
          // console.log('performanceLack callback: ')
        },
      });
    },
    /* 预览&对讲 */
    realplay() {
      let { player, mode, urls } = this,
        index = player.currentWindowIndex,
        playURL = urls.realplay;
      this.loading = true;
      player.JS_Play(playURL, { playURL, mode }, index).then(
        () => {
          console.log("realplay success");
          this.loading = false;
        },
        (e) => {
          console.log("realplay faild");
          this.loading = false;
          this.failNum += 1;
          if (this.failNum <= 3) {
            this.realplay();
          } else {
            this.failShow = true;
          }
        }
      );
    },
  },
  mounted() {
    this.urls.realplay = this.options.url;
    this.init();
    this.createPlayer();
    this.realplay();
  },
};
</script>

<style lang="scss" scoped>
#realVideo {
  width: 100%;
  height: 600px;
  position: relative;
  background: #4c4c4c;
  .loadImg {
    position: relative;
    top: 0;
    left: 47%;
    img {
      width: 50px;
      height: 50px;
    }
  }
  .failtip {
    position: relative;
    top: 0;
    left: 46%;
    font-size: 16px;
    color: #fff;
  }
}
</style>
